import { render, staticRenderFns } from "./deleteContractDialog.vue?vue&type=template&id=a1a23dfe&scoped=true"
import script from "./deleteContractDialog.vue?vue&type=script&lang=js"
export * from "./deleteContractDialog.vue?vue&type=script&lang=js"
import style0 from "./deleteContractDialog.vue?vue&type=style&index=0&id=a1a23dfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1a23dfe",
  null
  
)

export default component.exports